<script lang="ts">
  import IllustrationAnimee from '../../accueil/animation/IllustrationAnimee.svelte';
  import HerosEntreprises from './HerosEntreprises.svelte';

  const scènes = [HerosEntreprises];
</script>

<IllustrationAnimee
  {scènes}
  étiquette="Trois collègues échangent autour d'un ordinateur portable dans un bureau. Sécurité renforcée : garantir la continuité des activités."
/>
